import styled from 'styled-components';

import { multipleLineTextEllipse } from '../../style/reusableStyle';

export const TimelineContainer = styled.div`
  width: 100%;
  & .vertical-timeline {
    width: 100%;
  }

  & .vertical-timeline-event {
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 5px 0px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      height: 100%;
      left: calc(90px + 9px);
      width: 2px;
      background-color: ${({ theme }) => theme.colors.disableButtonText};
    }
  }

  & .timeline-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 4px solid #1d8a5a;
    margin-right: 10px;
    position: relative;
    background-color: #fff;
  }

  & .event-date {
    width: 90px;
    color: #949494;
  }

  & .event-details {
    max-width: calc(100% - 150px);
  }

  & .event-title {
    margin-top: 0;
  }

  & .event-description {
    margin-bottom: 0;
    ${multipleLineTextEllipse(1)};
  }
`;
